export enum BusinessToolsPermissions {
  UpdateReport = 'UpdateReport',
  OrgAdmin = 'OrgAdmin',
  ShowTestUsers = 'ShowTestUsers',
  ViewSubscriptionDetails = 'ViewSubscriptionDetails',
}
